// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"32921bb2","950":"68c8c283"}[chunkId] + ".chunk.css";
};